export { getBreadcrumbProductOfferSchema } from "./getBreadcrumbProductOfferSchema";